import {
  callApiGetDanhSachNhomLamViecPaging,
  callApiUpdateDsVanBanLienQuan,
  callApiSoLuongVbdById,
  callApiGetDashboardVanBanDen,
  callApiTaoQrPDF,
  callApiGetDanhSachVanBanDen,
  callApiGetChiTietTraCuuVanBanDen,
  callApiGetTrangThaiVanBanDen,
  callApiGetDanhSachThuHoi,
  callApiThuHoi,
  callApiXoaVanBan,
  callApiGetDanhSachTraLai,
  callApiLayLoaiVanBanDen,
  callApiLaySoVanBanDen,
  callApiLayPhuongThucNhan,
  callApiLayLoaiVanBan,
  callApiLayDoKhan,
  callApiLayDonViNgoai,
  callApiLayOptionDonVi,
  callApiLaySoDen,
  callApiVaoSoVanBan,
  callApiSaoChepVanBan,
  callApiChoVaoSo,
  callApiLayChiTietVanBanDen,
  callApiVaoSoDienTu,
  callApiTraLai,
  callApiCapNhatVanBanDenDangThucHien,
  callApiUploadFile,
  callApiUploadMultiFile,
  callGetDanhSachFileByListId,
  callApiLayDanhSachGuiNhan,
  callApiLayDanhSachFileVanBanDen,
  callApiLayDanhSachLichSuVanBanDen,
  callApiLayDanhSachYKienVanBan,
  callApiSoVanBanDenMoiNhat,
  callApiLaySoVanBan,
  callApiThemMoiYKienVanBan,
  callApiCapNhatHoanThanhYkienXuLy,
  callApiSyncVanBanTuTruc,
  callApiSuaYKienVanBan,
  callApiXoaYKienVanBan,
  callApiLayDanhSachLuongXuLy,
  callApiLayDanhSachLuongXuLyToken,
  callApiDownloadExportVanBan,
  callApiGetCanBoXinYKien,
  callApiGetCanBoXinYKienJson,
  callApiXinYKienXuLy,
  callApiLayDanhSachLanhDaoDonVi,
  callApiLayDanhSachLichSuXinYKienXuLy,
  callApiDongBoVanBan,
  callApiScanVanBan,
  callApiLayDanhSachNhomLamViec,
  callApiTraLoiYKienVanBanDen,
  callApiSuaXinYKienVanBanDen,
  callApiXoaNhomLamViec,
  callApiSuaNhomLamViec,
  callApiGetDonViXuLy,
  callApiGetAllDonViXuLy,
  callApiGetDonViKyDuyet,
  callApiPhanXuLy,
  callApiGetTrangThaiVanBan,
  callApiLayDanhSachSoByDonVi,
  callApiTaoNhomPhanXuLy,
  callApiGetVanBanDiResponse,
  callApiMarkAsReadByLanhDaoBo,
  callApiTuChoi,
  callApiDanhSachDonViCaNhanDuocXuLy,
  callApiCapNhatVanBanHoiBao,
  callApiYeuCauThuHoi,
  callApiYeuCauTraLai, callApiThuHoiBaoCaoLanhDao, callApiButPhe, callApiGetDonViXinYKien,
} from "@/api/van-ban-den";
import Vue from "vue";
import { callApiTimKiemVanBan, callApiTraCuuLayLaiVanBan } from "@/api/van-ban";
import { callApiGetDonViXuLyMulti } from "../../../api/nhiem-vu";

const layDanhSachVanBanDen = (context, payload) => {
  context.commit("DANH_SACH_VAN_BAN_DEN", {
    Data: {
      PageData: []
    }
  });
  return new Promise((resolve, reject) => {
    callApiGetDanhSachVanBanDen(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_VAN_BAN_DEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("DANH_SACH_VAN_BAN_DEN", {
          Data: {
            PageData: []
          }
        });
        reject(error);
      });
  });
};

const layDanhSachVanBanDenTraCuu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachVanBanDen(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const layChiTietTraCuuVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetChiTietTraCuuVanBanDen(payload)
        .then((response) => {
          if (response) {
            context.commit("CHI_TIET_VAN_BAN_DEN", response.data);
          }
          resolve(response);
        })
        .catch((error) => {
          context.commit("CHI_TIET_VAN_BAN_DEN", {
            Data: {
              PageData: []
            }
          });
          reject(error);
        });
  });
};

const layDanhSachVanBanDenNotState = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachVanBanDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachTatCaTrangThaiVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTrangThaiVanBanDen(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_TAT_CA_TRANG_THAI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDashboardVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDashboardVanBanDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachCotVanBanDen = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_VAN_BAN_DEN", payload);
};

const capNhatDanhSachCotVanBanDen = (context, payload) => {
  context.commit("CAP_NHAT_DANH_SACH_COT_VAN_BAN_DEN", payload);
};

const layDanhSachDonViThuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachThuHoi(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_DON_VI_THU_HOI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layNguoiBiTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachTraLai(payload)
      .then((response) => {
        if (response) {
          context.commit("NGUOI_BI_TRA_LAI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLoaiVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLoaiVanBanDen(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_LOAI_VAN_BAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layDanhSachSoVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLaySoVanBanDen(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_SO_VAN_BAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const thuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThuHoi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const tuChoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTuChoi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachPhuongThucNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayPhuongThucNhan(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_PHUONG_THUC_NHAN", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const xoaVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLoaiVanBanChuaVaoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLoaiVanBan(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_LOAI_VAN_BAN_CHUA_VAO_SO", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDoKhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDoKhan(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_DO_KHAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDonViNgoai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDonViNgoai(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_DON_VI_NGOAI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachDonViNgoaiKhongLienThong = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDonViNgoai(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_DON_VI_NGOAI_KO_LIEN_THONG", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachOptionDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayOptionDonVi(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_OPT_DON_VI", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachOptionDonViNotState = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayOptionDonVi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const laySoDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLaySoDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layChiTietVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietVanBanDen(payload)
      .then((response) => {
        if (response) {
          context.commit("CHI_TIET_VAN_BAN_DEN", response.data);
        }
        if (context.state.danhSachVanBanDen.Data) {
          const result = context.state.danhSachVanBanDen.Data.PageData.map(item => {
            if (item.Id === payload.processId) {
              return {
                ...item,
                DaXem: true
              }
            }
            return item
          })
          context.commit("DANH_SACH_VAN_BAN_DEN", {
            ...context.state.danhSachVanBanDen,
            Data: {
              ...context.state.danhSachVanBanDen.Data,
              PageData: result
            }
          })
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const vaoSoVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiVaoSoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const saoChepVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSaoChepVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const vaoSoDienTu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiVaoSoDienTu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatDangThucHien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVanBanDenDangThucHien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiFile = (context, payload) => {
  return new Promise((resolve) => {
    callApiUploadFile(payload)
      .then((response) => {
        if (!response.data.IsSuccess) {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        Vue.toasted.global.showErrorMessage({
          message: error,
        });
      });
  });
};

const themMoiNhieuFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUploadMultiFile(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const butPhe = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiButPhe(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const layDanhSachGuiNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachGuiNhan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuVanBanDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachFileVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachFileVanBanDen(payload)
      .then((response) => {
        context.commit("DANH_SACH_FILE_VAN_BAN_DEN", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachFileByListId = (context, payload) => {
  return new Promise((resolve, reject) => {
    callGetDanhSachFileByListId(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const laySoVanBanMoiNhat = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSoVanBanDenMoiNhat(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const laySoVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLaySoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachYKien = (context, payload) => {
  context.commit("LAY_DANH_SACH_Y_KIEN_XU_LY_VAN_BAN", []);
  return new Promise((resolve, reject) => {
    callApiLayDanhSachYKienVanBan(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_Y_KIEN_XU_LY_VAN_BAN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiYkienVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiYKienVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatHoanThanhYkienXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatHoanThanhYkienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const capNhatVanBanHoiBao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatVanBanHoiBao(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const syncVanBanTuTruc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSyncVanBanTuTruc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaYkienVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaYKienVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLoiYKienVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLoiYKienVanBanDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaXinYKienVanBanDen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaXinYKienVanBanDen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaYkienVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaYKienVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLuongXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLuongXuLy(payload)
      .then((response) => {
        context.commit("DANH_SACH_XEM_LUONG_PHAN_XU_LY", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLuongXuLyToken = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLuongXuLyToken(payload)
      .then((response) => {
        context.commit("DANH_SACH_XEM_LUONG_PHAN_XU_LY", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// eslint-disable-next-line no-unused-vars
const clearDanhSachLuongXuLy = (context, payload) => {
  context.commit("DANH_SACH_XEM_LUONG_PHAN_XU_LY", []);
};

///create by nhthai
const dongBoVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDongBoVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const choVaoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChoVaoSo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const downloadExportVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadExportVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLanhDaoDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLanhDaoDonVi(payload)
      .then((response) => {
        context.commit("DANH_SACH_DON_VI_LANH_DAO", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCanBoXinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCanBoXinYKien(payload)
      .then((response) => {
        context.commit("LAY_DANH_SACH_CAN_BO_XIN_Y_KIEN", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCanBoXinYKienJson = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCanBoXinYKienJson(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXinYKienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachLichSuXinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachLichSuXinYKienXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const scanVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiScanVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const soLuongVbdById = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSoLuongVbdById(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

const taoQrPDF = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoQrPDF(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const layDanhSachNhomLamViecPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachNhomLamViecPaging(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_NHOM_LAM_VIEC_PAGING", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachNhomLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNhomLamViec(payload)
      .then((response) => {
        context.commit("LAY_DANH_SACH_NHOM_LAM_VIEC", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaNhomLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNhomLamViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaNhomLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaNhomLamViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLy(payload, typeof payload === 'object')
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getDonViXinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXinYKien(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViXuLyMulti = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViXuLyMulti()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getAllDonViXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAllDonViXuLy(payload, typeof payload === 'object')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const getDonViKyDuyet = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViKyDuyet(payload, typeof payload === 'object')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const phanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPhanXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const thuHoiBaoCaoLanhDao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThuHoiBaoCaoLanhDao(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const timKiemVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTimKiemVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateVanBanLienQuan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateDsVanBanLienQuan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getTrangThaiVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetTrangThaiVanBan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachSoByDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachSoByDonVi(payload)
      .then((response) => {
        context.commit("DANH_SACH_SO_BY_DON_VI", response.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const taoNhomPhanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoNhomPhanXuLy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getVanBanDiResponse = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetVanBanDiResponse(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const markAsReadByLanhDaoBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiMarkAsReadByLanhDaoBo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhSachDonViCaNhanPXL = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDanhSachDonViCaNhanDuocXuLy(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_DON_VI_CA_NHAN_PXL", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const yeuCauThuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiYeuCauThuHoi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const yeuCauTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiYeuCauTraLai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traCuuLayLaiVanBan = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiTraCuuLayLaiVanBan(id)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  layDanhSachFileByListId,
  updateVanBanLienQuan,
  timKiemVanBan,
  phanXuLy,
  thuHoiBaoCaoLanhDao,
  getDonViXuLy,
  getDonViXinYKien,
  getDonViXuLyMulti,
  getAllDonViXuLy,
  getDonViKyDuyet,
  xoaNhomLamViec,
  suaNhomLamViec,
  getCanBoXinYKienJson,
  layDashboardVanBanDen,
  taoQrPDF,
  choVaoSo,
  layDanhSachVanBanDen,
  layDanhSachVanBanDenTraCuu,
  layChiTietTraCuuVanBanDen,
  layDanhSachVanBanDenNotState,
  layDanhSachCotVanBanDen,
  capNhatDanhSachCotVanBanDen,
  layDanhSachTatCaTrangThaiVanBanDen,
  layDanhSachDonViThuHoi,
  thuHoi,
  layDanhSachLoaiVanBanDen,
  layDanhSachSoVanBanDen,
  layDanhSachPhuongThucNhan,
  layDanhSachLoaiVanBanChuaVaoSo,
  layDanhSachDoKhan,
  xoaVanBan,
  layDanhSachDonViNgoai,
  layDanhSachDonViNgoaiKhongLienThong,
  layDanhSachOptionDonVi,
  layDanhSachOptionDonViNotState,
  laySoDen,
  layChiTietVanBanDen,
  vaoSoVanBanDen,
  vaoSoDienTu,
  layNguoiBiTraLai,
  traLai,
  tuChoi,
  capNhatDangThucHien,
  themMoiFile,
  themMoiNhieuFile,
  butPhe,
  layDanhSachFileVanBanDen,
  layDanhSachGuiNhan,
  layDanhSachLichSuVanBanDen,
  laySoVanBanMoiNhat,
  laySoVanBan,
  layDanhSachYKien,
  themMoiYkienVanBan,
  capNhatHoanThanhYkienXuLy,
  capNhatVanBanHoiBao,
  syncVanBanTuTruc,
  suaYkienVanBan,
  xoaYkienVanBan,
  layDanhSachLuongXuLy,
  dongBoVanBan,
  downloadExportVanBan,
  getCanBoXinYKien,
  xinYKien,
  layDanhSachLanhDaoDonVi,
  layDanhSachLichSuXinYKien,
  scanVanBan,
  layDanhSachNhomLamViec,
  traLoiYKienVanBanDen,
  soLuongVbdById,
  suaXinYKienVanBanDen,
  getTrangThaiVanBan,
  layDanhSachSoByDonVi,
  clearDanhSachLuongXuLy,
  taoNhomPhanXuLy,
  getVanBanDiResponse,
  markAsReadByLanhDaoBo,
  layDanhSachLuongXuLyToken,
  layDanhSachNhomLamViecPaging,
  danhSachDonViCaNhanPXL,
  saoChepVanBanDen,
  yeuCauThuHoi,
  yeuCauTraLai,
  traCuuLayLaiVanBan
};
